import { createStore } from "vuex";
import { authPageModule } from "./auth-store/index.js";
import { catePageModule } from "./cate-store/index.js";
import { sectorPageModule } from "./sector-store/index.js";
import { entPageModule } from "./ent-store/index.js";
import { dashPageModule } from "./dash-store/index.js";
import { feeTypePageModule } from "./fee-type-store/index.js";
export default createStore({
  state: {
    LoadingOverlay: false,
    snackbarSuccess: false,
    snackbarFailed: false,
    msg: "",
  },
  getters: {},
  mutations: {
    snackbarSuccess(state, value) {
      state.snackbarSuccess = value;
    },
    snackbarFailed(state, { value, msg }) {
      state.snackbarFailed = value;
      state.msg = msg;
    },
    LoadingOverlay(state, value) {
      state.LoadingOverlay = value;
    },
  },
  actions: {},
  modules: {
    authPageModule,
    catePageModule,
    sectorPageModule,
    entPageModule,
    dashPageModule,
    feeTypePageModule,
  },
});
